import { useSlice } from "@bridge-applications/provider-kit";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    commerceRewardCollection,
    commerceRewardSounds,
} from "../helpers/commerceRewardCollection";
import { useRewardCollectionSound } from "./useRewardCollectionSound";

export function useCommerceRewardCollection() {
    const { t } = useTranslation();
    const { state: auth } = useSlice("authSlice");
    const { state, setSlice } = useSlice("commerceSlice");
    const collection =
        auth.userId === state.rewardCollection?.userId
            ? (state.rewardCollection?.queue[0] ?? null)
            : null;
    const fadeSound = useRewardCollectionSound(
        collection?.orderId ?? null,
        commerceRewardSounds(collection),
    );

    useEffect(() => {
        if (
            state.rewardCollection &&
            state.rewardCollection.userId !== auth.userId
        )
            setSlice({ rewardCollection: null });
    }, [auth.userId, state.rewardCollection, setSlice]);

    const complete = useCallback(
        (orderId: string) => {
            setSlice((current) => {
                const session = current.rewardCollection;
                if (
                    session?.userId !== auth.userId ||
                    session?.queue[0]?.orderId !== orderId
                )
                    return {};
                return {
                    rewardCollection: {
                        ...session,
                        queue: session.queue.slice(1),
                    },
                };
            });
        },
        [auth.userId, setSlice],
    );

    return {
        presentation: commerceRewardCollection(collection, t),
        fadeSound,
        complete,
    };
}
